export default __webpack_public_path__ + "static/media/workouttimes_4.bd75c320.jpg";